import { Injectable } from '@angular/core';
import { GroupMenuDto, GroupMenu, GroupMenuPayload } from '../../models/system-settings/group-menus.model';

@Injectable({
  providedIn: 'root',
})
export class MapperGroupMenusService {
  // ================= Normal Functions =================

  constructor() { }

  /**
   * Maps a single GroupMenuDto to GroupMenu model.
   * @param dto GroupMenuDto from API
   */
  mapGroupMenuFromDto(dto: GroupMenuDto): GroupMenu {
    return {
      id: dto.id,
      name: dto.name || '',
      status: dto.status ?? false,
      number: dto.number || 0,
      createDate: dto.createDate ? new Date(dto.createDate) : null,
      writeDate: dto.writeDate ? new Date(dto.writeDate) : null,
    };
  }

  /**
   * Maps a single GroupMenu model to GroupMenuDto payload. (Deprecated: Use mapGroupMenuToPayload instead for POST/PUT)
   * @param model GroupMenu model from UI
   */
  mapGroupMenuToDto(model: GroupMenu): GroupMenuDto {
    return {
      id: model.id,
      name: model.name,
      status: model.status,
      number: model.number,
      createDate: model.createDate ? model.createDate.toISOString() : null,
      writeDate: model.writeDate ? model.writeDate.toISOString() : null,
    };
  }

  /**
   * Maps a GroupMenu model to the payload format required by insertGroupMenu and updateGroupMenu APIs.
   * @param model GroupMenu model from UI
   * @param userId ID of the user performing the action
   * @param menuId ID of the menu page where the action occurs
   */
  mapGroupMenuToPayload(model: GroupMenu, userId: number, menuId: number): GroupMenuPayload {
    return {
      // id: model.id,
      name: model.name,
      status: model.status,
      number: model.number,
      userId: userId,
      menuId: menuId
    };
  }
}
